const styles = theme => ({
    formControl: {
        margin: theme.spacing(0),
    },
    buttons: {
        position: 'relative'
    },
    button: {
        width: '100%',
        marginRight: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
    },
    radio: {
        minWidth: '110px',
        alignItems: 'start'
    },
    selectButton: {
        marginTop: theme.spacing(1.7),
        width: '100%',
    },
    errorText: {
        color: theme.palette.error.main + '!important',
        fontSize: '0.9rem!important',
        marginTop: '4px!important',
        textAlign: theme.errorText && theme.errorText.textAlign ? theme.errorText.textAlign : 'center!important',
    },
    lgTitle: {
        fontSize: '1.5rem',
        marginBottom: theme.spacing(1.5),
        color: theme.palette.text.primary,
        lineHeight: 1.15
    },
    customTitleSize: {
        marginTop: theme.spacing(1),
    },
    optionHelper: {
        color: theme.body2Color,
        textAlign: theme.optionHelper ? theme.optionHelper.textAlign : ''
    },
    checkboxOptionHelper: {
        marginTop: 0 + 'px!important',
        marginBottom: theme.spacing(2) + 'px!important',
        paddingLeft: '36px!important',
        color: theme.body2Color,
        textAlign: theme.optionHelper ? theme.optionHelper.textAlign : ''
    },
    label: {
        marginBottom: theme.spacing(1.5) + 'px!important',
    },
    group: {
        marginTop: 15
    },
    imageSelectButton: {
        marginTop: theme.spacing(1.7),
        width: '100%',
        padding: 0,
        display: 'block'
    },
    buttonImage: {
        maxWidth: '100%',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        width: '100%',
        paddingTop: '75%'
    },
    buttonWithoutImage: {
        padding: 6,
    },
    imageSelectLabel: {
        background: '#fff',
        paddingTop: 6,
        paddingBottom: 4,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
    },
    selectedButtonImageLabel: {
        background: theme.palette.primaryColor,
        color: '#fff',
    },
    companyDetails: {
        background: 'white',
        //border: '2px solid rgba(0, 0, 0, 0.23)',
        //padding: '13px 18px 8px',
        borderBottom: '1px solid rgb(148, 148, 148)',
        //borderRadius: '32px',
        margin: '0',
        marginLeft: '-1px!important',
        marginRight: '-1px!important',
        width: 'calc(100% + 2px)!important'
    },
    companyNameDetail: {
        fontSize: '1.2rem!important',
        fontWeight: 600 + '!important',
        marginBottom: theme.spacing(0.4),
    },
    companyDetail: {
        fontSize: '1rem!important',
        marginBottom: theme.spacing(0.25),
    },
    questionWrapper: {
        marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down(600)]: {
        questionWrapper: {
            padding: '4px!important'
        }
    },
    changeCompany: {
        color: theme.palette.primaryColor + '!important',
        fontWeight: 500,
        display: 'block',
        textAlign: 'center',
        marginTop: 4,
        cursor: 'pointer',
    },
    businessId: {
        color: 'rgba(0,0,0,0.54)',
        fontWeight: 500,
    },
    suggestion: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(0),
        textAlign: 'center',
    },
    businessIdToggle: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        cursor: 'pointer',
        textAlign: 'center',
    }
});
export {styles};
